export const getLDClientId = () => {
    let launchDarklyClientId = '6695466c3e8efc102093f3ee'; // Default: use production clientId.
    const hostname = window.location.host;

    if (
        hostname === 'localhost' ||
        hostname === 'foobar.localhost' ||
        hostname.startsWith('127.0.0.1') ||
        hostname.startsWith('localhost:')
    ) {
        // "Test" environment
        launchDarklyClientId = '6695466c3e8efc102093f3ed';
    } else if (
        hostname.endsWith('.customerportal-stage.servicetitan.com') ||
        hostname.endsWith('.stage.servicetitan.com') ||
        hostname === 'stage.servicetitan.com' ||
        hostname.endsWith('.stage.devtest.financing.srv.st.dev')
    ) {
        // "Stage" environment
        launchDarklyClientId = '669574e79324f1104d6cf800';
    } else if (hostname?.endsWith('.st.dev')) {
        // "QA" environment
        launchDarklyClientId = '6695750ae08568103d6fb20e';
    }

    return launchDarklyClientId;
};
